import React from "react";
import PropTypes from "prop-types";

const CompleteCircle = (props) => {
  const { color, width, height, ...other } = props;

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      {...other}
    >
      <circle id="bg" cx="10" cy="10" r="10" fill={color} />
      <g id="icon-check" transform="translate(0.769 0.769)">
        <path
          id="Shape"
          d="M0,0H18.462V18.462H0Z"
          fill="none"
          fillRule="evenodd"
        />
        <path
          id="Path-94"
          d="M1.355,8.96a.769.769,0,1,1-1.172-1L6.722.271a.769.769,0,0,1,1.1-.077L11.28,3.271a.769.769,0,1,1-1.022,1.15L7.384,1.867Z"
          transform="translate(15 13.846) rotate(180)"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

CompleteCircle.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

CompleteCircle.defaultProps = {
  color: "#000000",
  width: 24,
  height: 24,
};

export default CompleteCircle;



// WEBPACK FOOTER //
// ./src/components/Icons/CompleteCircle.jsx